import React from 'react';
import '../template-file-css/document-file-template.css';


export const OABS_BhaChild = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='OABS_BhaChild' className='file-pdf-document'>

            <div className='file-template'> 

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Parent/Primary Caretaker Name</span>
                            <span className='small'>(first, middle, last)</span>
                            <input type='text' id="txtParent" name="txtParent" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Is this person, the legal guardian?</span>
                            <input type="radio" id="rbLegalGuard_Yes" name="rbLegalGuard" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbLegalGuard_No" name="rbLegalGuard" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Legal Guardian Name</span>
                            <input type='text' id="txtLegalGuardName" name="txtLegalGuardName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Title/Department</span>
                            <input type='text' id="txtLegalTitle" name="txtLegalTitle" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone Number</span>
                            <input type='text' id="txtLegalPhone" name="txtLegalPhone" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h2>Behavioral Health History</h2>
                <p className='w-750'>
                    <span className='eleHeader'>Chief Complaint</span>
                    <span className='small'>Major symptoms, difficulties, and/or Issues as they relate to behavioral health -in recipient's own words/quoted.</span>
                    <textarea id="txtChiefComplaint" name="txtChiefComplaint" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Presenting Problem/History of Present Illness</span>
                    <span className='small'>(Including recipient's reason for seeking services, precipitating factors, symptoms, behavioral and functioning impacts, onset/course of issues, current behavioral health providers, services sought and recipient expectation.)</span>
                    <textarea id="txtPresentPrb" name="txtPresentPrb" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Behavioral Health Provider Name</span>
                            <input type='text' id="txtCurrentBxProvider" name="txtCurrentBxProvider" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone Number</span>
                            <input type='text' id="txtCurrentBxProviderPhone" name="txtCurrentBxProviderPhone" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Prior Outpatient Mental Health Treatment</span>
                    <input type="checkbox" id="cb3_Outpatient" name="cb3_Outpatient" className='add-only' value="None" /> None<br />
                    <textarea id="txtPastPsychHx" name="txtPastPsychHx" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Psychiatric Hospitalizations</span>
                    <input type="checkbox" id="cb3_Inpatient" name="cb3_Inpatient" className='add-only' value="None" /> None<br />
                    <textarea id="txtPsychiatric" name="txtPsychiatric" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Prior Residential/Out of Home Placement</span>
                    <input type="checkbox" id="cb3_OutOfHome" name="cb3_OutOfHome" className='add-only' value="None" /> None<br />
                    <textarea id="txtPriorRes" name="txtPriorRes" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Additional History/Comments</span>
                    <textarea id="txtAdditionalHx" name="txtAdditionalHx" className='add-only'></textarea>
                </p>
                <h2>Substance Abuse/Dependence</h2>
                <p className='w-750'><input type="checkbox" id="cb_SubsAbuse" name="cb_SubsAbuse" className='add-only' value="None" /> None</p>
                <h6>(Past use of primary, secondary & tertiary current substance, incl. type, freq, method & age of 1st use.)</h6>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Check any/all that apply in last 12 months</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSA_1" name="cbSA" className='add-only' value="Alcohol Use" /> Alcohol Use</td>
                        <td className='w-250'><input type="checkbox" id="cbSA_2" name="cbSA" className='add-only' value="Illegal Drug Use" /> Illegal Drug Use</td>
                        <td className='w-250'><input type="checkbox" id="cbSA_3" name="cbSA" className='add-only' value="Injected Drug Use" /> Injected Drug Use</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSA_4" name="cbSA" className='add-only' value="Tobacco Product Use" /> Tobacco Product Use</td>
                        <td className='w-250'><input type="checkbox" id="cbSA_5" name="cbSA" className='add-only' value="Prescription Drugs Abuse" /> Prescription Drugs Abuse</td>
                        <td className='w-250'><input type="checkbox" id="cbSA_6" name="cbSA" className='add-only' value="Non-Prescription (OTC) abuse" /> Non-Prescription (OTC) abuse</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSA_7" name="cbSA" className='add-only' value="Alcohol and/or Drug Overdose" /> Alcohol and/or Drug Overdose</td>
                        <td className='w-250'><input type="checkbox" id="cbSA_8" name="cbSA" className='add-only' value="Alcohol and/or Drug Withdrawal" /> Alcohol and/or Drug Withdrawal</td>
                        <td className='w-250'><input type="checkbox" id="cbSA_9" name="cbSA" className='add-only' value="Problems Cause by Gambling" /> Problems Cause by Gambling</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSA_10" name="cbSA" className='add-only' value="Trouble Stopping Any Substance" /> Trouble Stopping Any Substance</td>
                        <td className='w-250'><input type="checkbox" id="cbSA_11" name="cbSA" className='add-only' value="Caffeine Use" /> Caffeine Use</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSA_12" name="cbSA" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtSA_12" name="txtSA_12" className='add-only' />
                </p>

                <span className='eleHeader'>Substance Abuse Treatment History</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSATxHx_1" name="cbSATxHx" className='add-only' value="None" /> None</td>
                        <td className='w-250'><input type="checkbox" id="cbSATxHx_2" name="cbSATxHx" className='add-only' value="Outpatient" /> Outpatient</td>
                        <td className='w-250'><input type="checkbox" id="cbSATxHx_3" name="cbSATxHx" className='add-only' value="Intensive Outpatient" /> Intensive Outpatient</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSATxHx_4" name="cbSATxHx" className='add-only' value="Residential/Inpatient" /> Residential/Inpatient</td>
                        <td className='w-250'><input type="checkbox" id="cbSATxHx_5" name="cbSATxHx" className='add-only' value="Detox" /> Detox</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSATxHx_6" name="cbSATxHx" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtSATxHx_6" name="txtSATxHx_6" className='add-only' />
                </p>

                {/* <table>
                    <tr>
                        <td className='w-150'>SUBSTANCE TYPE<br />Include all used in last 30 days</td>
                        <td className='w-75'>AGE OF<br />1ST USE</td>
                        <td className='w-75'>YEARS IN<br />LIFETIME</td>
                        <td className='w-75'>DAYS IN<br />PAST 30</td>
                        <td className='w-75'>DAYS SINCE<br />LAST USE</td>
                        <td className='w-75'>AMOUNT</td>
                        <td className='w-225'>ROUTE OF ADMIN</td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtSA_1_1" name="txtSA_1_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_1_2" name="txtSA_1_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_1_3" name="txtSA_1_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_1_4" name="txtSA_1_4" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_1_5" name="txtSA_1_5" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_1_6" name="txtSA_1_6" className='add-only' /></td>
                        <td className='w-225'>
                            <input id="cbSA_1_7" name="cbSA_1_7" className='add-only' value="Oral" /> Oral
                            <input id="cbSA_1_8" name="cbSA_1_8" className='add-only' value="Nasal" /> Nasal
                            <input id="cbSA_1_9" name="cbSA_1_9" className='add-only' value="Smoke" /> Smoke
                            <input id="cbSA_1_10" name="cbSA_1_10" className='add-only' value="Non-IV Inj" /> Non-IV Inj
                            <input id="cbSA_1_11" name="cbSA_1_11" className='add-only' value="IV" /> IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtSA_2_1" name="txtSA_2_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_2_2" name="txtSA_2_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_2_3" name="txtSA_2_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_2_4" name="txtSA_2_4" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_2_5" name="txtSA_2_5" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_2_6" name="txtSA_2_6" className='add-only' /></td>
                        <td className='w-225'>
                            <input id="cbSA_2_7" name="cbSA_2_7" className='add-only' value="Oral" /> Oral
                            <input id="cbSA_2_8" name="cbSA_2_8" className='add-only' value="Nasal" /> Nasal
                            <input id="cbSA_2_9" name="cbSA_2_9" className='add-only' value="Smoke" /> Smoke
                            <input id="cbSA_2_10" name="cbSA_2_10" className='add-only' value="Non-IV Inj" /> Non-IV Inj
                            <input id="cbSA_2_11" name="cbSA_2_11" className='add-only' value="IV" /> IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtSA_3_1" name="txtSA_3_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_3_2" name="txtSA_3_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_3_3" name="txtSA_3_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_3_4" name="txtSA_3_4" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_3_5" name="txtSA_3_5" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_3_6" name="txtSA_3_6" className='add-only' /></td>
                        <td className='w-225'>
                            <input id="cbSA_3_7" name="cbSA_3_7" className='add-only' value="Oral" /> Oral
                            <input id="cbSA_3_8" name="cbSA_3_8" className='add-only' value="Nasal" /> Nasal
                            <input id="cbSA_3_9" name="cbSA_3_9" className='add-only' value="Smoke" /> Smoke
                            <input id="cbSA_3_10" name="cbSA_3_10" className='add-only' value="Non-IV Inj" /> Non-IV Inj
                            <input id="cbSA_3_11" name="cbSA_3_11" className='add-only' value="IV" /> IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtSA_4_1" name="txtSA_4_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_4_2" name="txtSA_4_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_4_3" name="txtSA_4_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_4_4" name="txtSA_4_4" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_4_5" name="txtSA_4_5" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_4_6" name="txtSA_4_6" className='add-only' /></td>
                        <td className='w-225'>
                            <input id="cbSA_4_7" name="cbSA_4_7" className='add-only' value="Oral" /> Oral
                            <input id="cbSA_4_8" name="cbSA_4_8" className='add-only' value="Nasal" /> Nasal
                            <input id="cbSA_4_9" name="cbSA_4_9" className='add-only' value="Smoke" /> Smoke
                            <input id="cbSA_4_10" name="cbSA_4_10" className='add-only' value="Non-IV Inj" /> Non-IV Inj
                            <input id="cbSA_4_11" name="cbSA_4_11" className='add-only' value="IV" /> IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtSA_5_1" name="txtSA_5_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_5_2" name="txtSA_5_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_5_3" name="txtSA_5_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_5_4" name="txtSA_5_4" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_5_5" name="txtSA_5_5" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_5_6" name="txtSA_5_6" className='add-only' /></td>
                        <td className='w-225'>
                            <input id="cbSA_5_7" name="cbSA_5_7" className='add-only' value="Oral" /> Oral
                            <input id="cbSA_5_8" name="cbSA_5_8" className='add-only' value="Nasal" /> Nasal
                            <input id="cbSA_5_9" name="cbSA_5_9" className='add-only' value="Smoke" /> Smoke
                            <input id="cbSA_5_10" name="cbSA_5_10" className='add-only' value="Non-IV Inj" /> Non-IV Inj
                            <input id="cbSA_5_11" name="cbSA_5_11" className='add-only' value="IV" /> IV
                        </td>
                    </tr>
                </table> */}
                <table>
                    <tr>
                        <td className='w-150'>SUBSTANCE TYPE<br />Include all used in last 30 days</td>
                        <td className='w-75'>AGE OF<br />1ST USE</td>
                        <td className='w-75'>YEARS IN<br />LIFETIME</td>
                        <td className='w-75'>DAYS IN<br />PAST 30</td>
                        <td className='w-75'>DAYS SINCE<br />LAST USE</td>
                        <td className='w-100'>AMOUNT</td>
                        <td className='w-200'>ROUTE OF ADMIN</td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtSA_1_1" name="txtSA_1_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_1_2" name="txtSA_1_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_1_3" name="txtSA_1_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_1_4" name="txtSA_1_4" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_1_5" name="txtSA_1_5" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_1_6" name="txtSA_1_6" className='add-only' /></td>
                        <td className='w-225'>
                            <input type="checkbox" id="cbSA_1_7" name="cbSA_1_7" className='add-only' value="Oral" /> Oral &nbsp;
                            <input type="checkbox" id="cbSA_1_8" name="cbSA_1_8" className='add-only' value="Nasal" /> Nasal&nbsp;
                            <input type="checkbox" id="cbSA_1_9" name="cbSA_1_9" className='add-only' value="Smoke" /> Smoke &nbsp;<br />
                            <input type="checkbox" id="cbSA_1_10" name="cbSA_1_10" className='add-only' value="Non-IV Inj" /> Non-IV Inj &nbsp;
                            <input type="checkbox" id="cbSA_1_11" name="cbSA_1_11" className='add-only' value="IV" /> IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtSA_2_1" name="txtSA_2_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_2_2" name="txtSA_2_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_2_3" name="txtSA_2_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_2_4" name="txtSA_2_4" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_2_5" name="txtSA_2_5" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_2_6" name="txtSA_2_6" className='add-only' /></td>
                        <td className='w-225'>
                            <input type="checkbox" id="cbSA_2_7" name="cbSA_2_7" className='add-only' value="Oral" /> Oral &nbsp;
                            <input type="checkbox" id="cbSA_2_8" name="cbSA_2_8" className='add-only' value="Nasal" /> Nasal&nbsp;
                            <input type="checkbox" id="cbSA_2_9" name="cbSA_2_9" className='add-only' value="Smoke" /> Smoke &nbsp;<br />
                            <input type="checkbox" id="cbSA_2_10" name="cbSA_2_10" className='add-only' value="Non-IV Inj" /> Non-IV Inj &nbsp;
                            <input type="checkbox" id="cbSA_2_11" name="cbSA_2_11" className='add-only' value="IV" /> IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtSA_3_1" name="txtSA_3_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_3_2" name="txtSA_3_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_3_3" name="txtSA_3_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_3_4" name="txtSA_3_4" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_3_5" name="txtSA_3_5" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_3_6" name="txtSA_3_6" className='add-only' /></td>
                        <td className='w-225'>
                            <input type="checkbox" id="cbSA_3_7" name="cbSA_3_7" className='add-only' value="Oral" /> Oral &nbsp;
                            <input type="checkbox" id="cbSA_3_8" name="cbSA_3_8" className='add-only' value="Nasal" /> Nasal&nbsp;
                            <input type="checkbox" id="cbSA_3_9" name="cbSA_3_9" className='add-only' value="Smoke" /> Smoke &nbsp;<br />
                            <input type="checkbox" id="cbSA_3_10" name="cbSA_3_10" className='add-only' value="Non-IV Inj" /> Non-IV Inj &nbsp;
                            <input type="checkbox" id="cbSA_3_11" name="cbSA_3_11" className='add-only' value="IV" /> IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtSA_4_1" name="txtSA_4_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_4_2" name="txtSA_4_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_4_3" name="txtSA_4_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_4_4" name="txtSA_4_4" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_4_5" name="txtSA_4_5" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_4_6" name="txtSA_4_6" className='add-only' /></td>
                        <td className='w-225'>
                            <input type="checkbox" id="cbSA_4_7" name="cbSA_4_7" className='add-only' value="Oral" /> Oral &nbsp;
                            <input type="checkbox" id="cbSA_4_8" name="cbSA_4_8" className='add-only' value="Nasal" /> Nasal&nbsp;
                            <input type="checkbox" id="cbSA_4_9" name="cbSA_4_9" className='add-only' value="Smoke" /> Smoke &nbsp;<br />
                            <input type="checkbox" id="cbSA_4_10" name="cbSA_4_10" className='add-only' value="Non-IV Inj" /> Non-IV Inj &nbsp;
                            <input type="checkbox" id="cbSA_4_11" name="cbSA_4_11" className='add-only' value="IV" /> IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtSA_5_1" name="txtSA_5_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_5_2" name="txtSA_5_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_5_3" name="txtSA_5_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_5_4" name="txtSA_5_4" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_5_5" name="txtSA_5_5" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtSA_5_6" name="txtSA_5_6" className='add-only' /></td>
                        <td className='w-225'>
                            <input type="checkbox" id="cbSA_5_7" name="cbSA_5_7" className='add-only' value="Oral" /> Oral &nbsp;
                            <input type="checkbox" id="cbSA_5_8" name="cbSA_5_8" className='add-only' value="Nasal" /> Nasal&nbsp;
                            <input type="checkbox" id="cbSA_5_9" name="cbSA_5_9" className='add-only' value="Smoke" /> Smoke &nbsp;<br />
                            <input type="checkbox" id="cbSA_5_10" name="cbSA_5_10" className='add-only' value="Non-IV Inj" /> Non-IV Inj &nbsp;
                            <input type="checkbox" id="cbSA_5_11" name="cbSA_5_11" className='add-only' value="IV" /> IV
                        </td>
                    </tr>
                </table>
                <h2>Physical</h2>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Current Medical Conditions</span>
                            <span className='small'>Check all that apply.</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbPhys_1" name="cbPhys" className='add-only' value="Pregnant" /> Pregnant</td>
                    </tr>
                </table>

                <p className='w-750'>
                    Due Date:&nbsp;
                    <input type='date' id='txtPhys_2' name='txtPhys_2' className='add-only w-200 custom-add-only' /> &nbsp;
                    Prenatal Care:&nbsp; <input type='text' id='txtPhys_3' name='txtPhys_3' className='add-only w-200 custom-add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbPhys_4" name="cbPhys" className='add-only' value="None Reported" /> None Reported</td>
                        <td className='w-250'><input type="checkbox" id="cbPhys_5" name="cbPhys" className='add-only' value="Congestive Heart Failure" /> Congestive Heart Failure</td>
                        <td className='w-250'><input type="checkbox" id="cbPhys_6" name="cbPhys" className='add-only' value="Asthma" /> Asthma</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbPhys_7" name="cbPhys" className='add-only' value="Seizure" /> Seizure</td>
                        <td className='w-250'><input type="checkbox" id="cbPhys_8" name="cbPhys" className='add-only' value="Cancer" /> Cancer</td>
                        <td className='w-250'><input type="checkbox" id="cbPhys_9" name="cbPhys" className='add-only' value="Underweight" /> Underweight</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbPhys_10" name="cbPhys" className='add-only' value="High Blood Pressure" /> High Blood Pressure</td>
                        <td className='w-250'><input type="checkbox" id="cbPhys_11" name="cbPhys" className='add-only' value="Stroke" /> Stroke</td>
                        <td className='w-250'><input type="checkbox" id="cbPhys_12" name="cbPhys" className='add-only' value="Emphysema" /> Emphysema</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbPhys_13" name="cbPhys" className='add-only' value="Cirrhosis" /> Cirrhosis</td>
                        <td className='w-250'><input type="checkbox" id="cbPhys_14" name="cbPhys" className='add-only' value="Chronic Pain" /> Chronic Pain</td>
                        <td className='w-250'><input type="checkbox" id="cbPhys_15" name="cbPhys" className='add-only' value="Overweight" /> Overweight</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbPhys_16" name="cbPhys" className='add-only' value="Heart Disease" /> Heart Disease</td>
                        <td className='w-250'><input type="checkbox" id="cbPhys_17" name="cbPhys" className='add-only' value="Diabetes" /> Diabetes</td>
                        <td className='w-250'><input type="checkbox" id="cbPhys_18" name="cbPhys" className='add-only' value="Epilepsy" /> Epilepsy</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbPhys_19" name="cbPhys" className='add-only' value="Digestive Problems" /> Digestive Problems</td>
                        <td className='w-250'><input type="checkbox" id="cbPhys_20" name="cbPhys" className='add-only' value="Thyroid Disease" /> Thyroid Disease</td>
                        <td className='w-250'><input type="checkbox" id="cbPhys_21" name="cbPhys" className='add-only' value="STD" /> STD</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbPhys_22" name="cbPhys" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtPhys_23" name="txtPhys_23" className='add-only' />
                </p>

                <h4>Current and Past Medications</h4>
                <h5>Including non-psychotropic medications</h5>
                <table>
                    <tr>
                        <td className='w-200'>Medication Name</td>
                        <td className='w-75'>Dose</td>
                        <td className='w-75'>Freq</td>
                        <td className='w-75'>Route</td>
                        <td className='w-75'>Current</td>
                        <td className='w-250'>Comments (Reason Prescribed/Response, etc)</td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtMed_1_1" name="txtMed_1_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_1_2" name="txtMed_1_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_1_3" name="txtMed_1_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_1_4" name="txtMed_1_4" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlMed_1_5" name="ddlMed_1_5" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id="txtMed_1_6" name="txtMed_1_6" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtMed_2_1" name="txtMed_2_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_2_2" name="txtMed_2_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_2_3" name="txtMed_2_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_2_4" name="txtMed_2_4" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlMed_2_5" name="ddlMed_2_5" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id="txtMed_2_6" name="txtMed_2_6" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtMed_3_1" name="txtMed_3_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_3_2" name="txtMed_3_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_3_3" name="txtMed_3_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_3_4" name="txtMed_3_4" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlMed_3_5" name="ddlMed_3_5" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id="txtMed_3_6" name="txtMed_3_6" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtMed_4_1" name="txtMed_4_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_4_2" name="txtMed_4_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_4_3" name="txtMed_4_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_4_4" name="txtMed_4_4" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlMed_4_5" name="ddlMed_4_5" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id="txtMed_4_6" name="txtMed_4_6" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtMed_5_1" name="txtMed_5_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_5_2" name="txtMed_5_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_5_3" name="txtMed_5_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_5_4" name="txtMed_5_4" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlMed_5_5" name="ddlMed_5_5" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id="txtMed_5_6" name="txtMed_5_6" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtMed_6_1" name="txtMed_6_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_6_2" name="txtMed_6_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_6_3" name="txtMed_6_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_6_4" name="txtMed_6_4" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlMed_6_5" name="ddlMed_6_5" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id="txtMed_6_6" name="txtMed_6_6" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtMed_7_1" name="txtMed_7_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_7_2" name="txtMed_7_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_7_3" name="txtMed_7_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_7_4" name="txtMed_7_4" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlMed_7_5" name="ddlMed_7_5" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id="txtMed_7_6" name="txtMed_7_6" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtMed_8_1" name="txtMed_8_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_8_2" name="txtMed_8_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_8_3" name="txtMed_8_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_8_4" name="txtMed_8_4" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlMed_8_5" name="ddlMed_8_5" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id="txtMed_8_6" name="txtMed_8_6" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtMed_9_1" name="txtMed_9_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_9_2" name="txtMed_9_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_9_3" name="txtMed_9_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_9_4" name="txtMed_9_4" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlMed_9_5" name="ddlMed_9_5" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id="txtMed_9_6" name="txtMed_9_6" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='text' id="txtMed_10_1" name="txtMed_10_1" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_10_2" name="txtMed_10_2" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_10_3" name="txtMed_10_3" className='add-only' /></td>
                        <td className='w-75'><input type='text' id="txtMed_10_4" name="txtMed_10_4" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlMed_10_5" name="ddlMed_10_5" className='add-only'>
                                <option value="NA"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'><input type='text' id="txtMed_10_6" name="txtMed_10_6" className='add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Allergies</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="radio" id="rbAllergiesNone" name="rbAllergies" className='add-only' value="No Reported Drug or Food Allergies" /> No Reported Drug or Food Allergies;
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type="radio" id="rbAllergiesOther" name="rbAllergies" className='add-only' value="Other" /> Other:
                            <input type='text' id="txtAllergiesOther" name="txtAllergiesOther" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <span className='eleHeader'>Primary Care Physican</span>
                            <input type='text' id="txtPcp" name="txtPcp" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Phone</span>
                            <input type='text' id="txtPcpPhone" name="txtPcpPhone" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Fax</span>
                            <input type='text' id="txtPcpFax" name="txtPcpFax" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Medical History</span>
                    <span className='small'>(Diagnosis, Hospitalizations, Surgery, labs values, status of conditions, etc.)</span>
                    <textarea id="txtAdditionalMedHx" name="txtAdditionalMedHx" className='add-only'></textarea>
                </p>
                <h2>Social</h2>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Current Legal Status</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbLegal_1" name="cbLegal_1" className='add-only' value="None" /> None</td>
                        <td className='w-250'><input type="checkbox" id="cbLegal_2" name="cbLegal_2" className='add-only' value="Parole" /> DCFS</td>
                        <td className='w-250'><input type="checkbox" id="cbLegal_3" name="cbLegal_3" className='add-only' value="Probation" /> Probation</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbLegal_4" name="cbLegal_4" className='add-only' value="Charges Pending" /> Charges Pending</td>
                        <td className='w-250'><input type="checkbox" id="cbLegal_5" name="cbLegal_5" className='add-only' value="OJJ" /> OJJ</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbLegal_6" name="cbLegal_6" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtLegalOther" name="txtLegalOther" className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Past Legal Status</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbPastLegal_1" name="cbPastLegal_1" className='add-only' value="None" /> None</td>
                        <td className='w-250'><input type="checkbox" id="cbPastLegal_2" name="cbPastLegal_2" className='add-only' value="DCFS" /> DCFS</td>
                        <td className='w-250'><input type="checkbox" id="cbPastLegal_3" name="cbPastLegal_3" className='add-only' value="OJJ" /> OJJ</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type="checkbox" id="cbPastLegal_5" name="cbPastLegal_5" className='add-only' value="Other" /> Other:</td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtPastLegal_Comment" name="txtPastLegal_Comment" className='add-only' />
                </p>

                <h4>Family History</h4>
                <h5>(relationship status with relatives, family involvement in treatment, and living status of significant relatives)</h5>
                <span className='eleHeader'>Custodial Status</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbCustodial_1" name="cbCustodial_1" className='add-only' value="Independent Adult" /> Independent Adult</td>
                        <td className='w-250'><input type="checkbox" id="cbCustodial_2" name="cbCustodial_2" className='add-only' value="Biologic Father" /> Biologic Father</td>
                        <td className='w-250'><input type="checkbox" id="cbCustodial_3" name="cbCustodial_3" className='add-only' value="Biologic Mother" /> Biologic Mother</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbCustodial_4" name="cbCustodial_4" className='add-only' value="Joint Biologic Parents" /> Joint Biologic Parents</td>
                        <td className='w-250'><input type="checkbox" id="cbCustodial_5" name="cbCustodial_5" className='add-only' value="Gov't/Judicial" /> Gov't/Judicial</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPastLegal_6" name="cbCustodial_6" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtPastLegal_Other" name="txtPastLegal_Other" className='add-only' />
                </p>

                <span className='eleHeader'>Adverse Circumstances in Family of Origin</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAdverseFOO_1" name="cbAdverseFOO_1" className='add-only' value="NA" /> N/A</td>
                        <td className='w-250'><input type="checkbox" id="cbAdverseFOO_2" name="cbAdverseFOO_2" className='add-only' value="Poverty" /> Poverty</td>
                        <td className='w-250'><input type="checkbox" id="cbAdverseFOO_3" name="cbAdverseFOO_3" className='add-only' value="Criminal Behavior" /> Criminal Behavior</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAdverseFOO_4" name="cbAdverseFOO_4" className='add-only' value="Mental Illness" /> Mental Illness</td>
                        <td className='w-250'><input type="checkbox" id="cbAdverseFOO_5" name="cbAdverseFOO_5" className='add-only' value="Substance Use" /> Substance Use</td>
                        <td className='w-250'><input type="checkbox" id="cbAdverseFOO_6" name="cbAdverseFOO_6" className='add-only' value="Abuse" /> Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAdverseFOO_7" name="cbAdverseFOO_7" className='add-only' value="Neglect" /> Neglect</td>
                        <td className='w-250'><input type="checkbox" id="cbAdverseFOO_8" name="cbAdverseFOO_8" className='add-only' value="Domestic Violence" /> Domestic Violence</td>
                        <td className='w-250'><input type="checkbox" id="cbAdverseFOO_9" name="cbAdverseFOO_9" className='add-only' value="Violence" /> Violence</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAdverseFOO_10" name="cbAdverseFOO_10" className='add-only' value="Trauma" /> Trauma</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFOO_12" name="cbAdverseFOO_12" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtAdverseFOO_12" name="txtAdverseFOO_12" className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Summarize family history and child-rearing practices</span>
                    <textarea id="txtFamHx" name="txtFamHx" className='add-only'></textarea>
                </p>
                <h4>Trauma History</h4>
                <span className='eleHeader'>History of Trauma</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbTraumaHx_1" name="cbTraumaHx_1" className='add-only' value="None" /> None</td>
                        <td className='w-250'><input type="checkbox" id="cbTraumaHx_2" name="cbTraumaHx_1" className='add-only' value="Experienced" /> Experienced</td>
                        <td className='w-250'><input type="checkbox" id="cbTraumaHx_3" name="cbTraumaHx_1" className='add-only' value="Witnessed" /> Witnessed</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbTraumaHx_4" name="cbTraumaHx_4" className='add-only' value="Abuse" /> Abuse</td>
                        <td className='w-250'><input type="checkbox" id="cbTraumaHx_5" name="cbTraumaHx_5" className='add-only' value="Neglect" /> Neglect</td>
                        <td className='w-250'><input type="checkbox" id="cbTraumaHx_6" name="cbTraumaHx_6" className='add-only' value="Violence" /> Violence</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbTraumaHx_7" name="cbTraumaHx_7" className='add-only' value="Sexual Assault" /> Sexual Assault</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTraumaHx_8" name="cbTraumaHx_8" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtTraumaHx_8" name="txtTraumaHx_8" className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Summarize trauma history</span>
                    <textarea id="txtTraumaHx" name="txtTraumaHx" className='add-only'></textarea>
                </p>
                <h4>Living Situation</h4>
                <h5>Current status and functioning</h5>
                <span className='eleHeader'>Primary Residence</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbPrimaryReside_1" name="cbPrimaryReside_1" className='add-only' value="Parent" /> Parent/Guardian Home</td>
                        <td className='w-250'><input type="checkbox" id="cbPrimaryReside_2" name="cbPrimaryReside_2" className='add-only' value="Out of Home placement" /> Out of Home placement</td>
                        <td className='w-250'><input type="checkbox" id="cbPrimaryReside_3" name="cbPrimaryReside_3" className='add-only' value="Relatives Home" /> Relative's Home</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbPrimaryReside_5" name="cbPrimaryReside_5" className='add-only' value="Homeless" /> Homeless</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbPrimaryReside_7" name="cbPrimaryReside_7" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtPrimaryReside_7" name="txtPrimaryReside_7" className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>How long at current residence?</span>
                            <input type='text' id="txtLongCurrReside" name="txtLongCurrReside" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Family/Household Composition</span>
                            <input type='text' id="txtFamilyComp" name="txtFamilyComp" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Summarize current living situation</span>
                    <textarea id="txtLivSitComments" name="txtLivSitComments" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Needs</span>
                    <span className='small'>-List what is needed to improve/maintain daily living situation (Ex. Transportation, ability to cook independently, housing subsidy, money in savings, care-giver resource assessment, etc.)</span>
                    <textarea id="txtNeeds" name="txtNeeds" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Preferences</span>
                    <span className='small'>Include things recipient feels will enhance his/her living situation.</span>
                    <textarea id="txtPreferences" name="txtPreferences" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Strengths</span>
                    <span className='small'>List assets, service options, and resources the person has to meet needs, including available housing options. (Ex. Knows area, applied for housing subsidy, can live with family member, unpaid care-giver resource available, etc.)</span>
                    <textarea id="txtStrengths" name="txtStrengths" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Abilities/Interests</span>
                    <span className='small'>Include recipient reported skills, aptitudes, capabilities, talents & competencies that might assist in maintaining or improving living situation.</span>
                    <textarea id="txtAbilities" name="txtAbilities" className='add-only'></textarea>
                </p>
                <h4>Educational/Employment Status</h4>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Educational Placement/Employer</span>
                            <input type='text' id="txtCurrEd" name="txtCurrEd" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current or Highest Grade Completed/Degree</span>
                            <input type='text' id="txtHighGrade" name="txtHighGrade" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Difficulties with Reading/Writing</span>
                            <input type="radio" id="rbRWDiff_Yes" name="rbRWDiff" className='add-only' value="yes" /> Yes &nbsp;
                            <input type="radio" id="rbRWDiff_No" name="rbRWDiff" className='add-only' value="no" /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Estimated Literacy Level</span>
                            <input type='text' id="txtEstLitLevel" name="txtEstLitLevel" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Summarize educational history and status</span>
                    <textarea id="txtSummEdHx" name="txtSummEdHx" className='add-only'></textarea>
                </p>
                <h4>Social History and Community Integration</h4>
                <table>
                    <tr>
                        <td className='w-350'>
                            <span className='eleHeader'>Current status and functioning</span>
                            <input type='text' id="txtCurrStatFunct" name="txtCurrStatFunct" className='add-only' />
                        </td>
                        <td className='w-400'>
                            <span className='eleHeader'>Does Client/Member feel supported by friends or family?</span>
                            <input type="radio" id="rbFeelSupp_Yes" name="rbFeelSupp" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbFeelSupp_No" name="rbFeelSupp" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Recreational Activities</span>
                    <textarea id="txtRecActivities" name="txtRecActivities" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Self-Help Activities</span>
                    <textarea id="txtSelfActivities" name="txtSelfActivities" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Summarize social and community involvement</span>
                    <textarea id="txtSummSocial" name="txtSummSocial" className='add-only'></textarea>
                </p>
                <h2>Current Status</h2>
                <h4>Mental Status Exam</h4>
                <span className='eleHeader'>General Appearance</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbGA_1" name="cbGA_1" className='add-only' value="Healthy" /> Healthy</td>
                        <td className='w-250'><input type="checkbox" id="cbGA_2" name="cbGA_2" className='add-only' value="As Stated Age" /> As Stated Age</td>
                        <td className='w-250'><input type="checkbox" id="cbGA_3" name="cbGA_3" className='add-only' value="Older Than Stated Age" /> Older Than Stated Age</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbGA_4" name="cbGA_4" className='add-only' value="Healthy" /> Healthy</td>
                        <td className='w-250'><input type="checkbox" id="cbGA_5" name="cbGA_5" className='add-only' value="As Stated Age" /> As Stated Age</td>
                        <td className='w-250'><input type="checkbox" id="cbGA_6" name="cbGA_6" className='add-only' value="Older Than Stated Age" /> Older Than Stated Age</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbGA_7" name="cbGA_7" className='add-only' value="Young-looking" /> Young-looking</td>
                        <td className='w-250'><input type="checkbox" id="cbGA_8" name="cbGA_8" className='add-only' value="Tattoos" /> Tattoos</td>
                        <td className='w-250'><input type="checkbox" id="cbGA_9" name="cbGA_9" className='add-only' value="Disheveled" /> Disheveled</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbGA_10" name="cbGA_10" className='add-only' value="Unkempt" /> Unkempt</td>
                        <td className='w-250'><input type="checkbox" id="cbGA_11" name="cbGA_11" className='add-only' value="Malodorous" /> Malodorous</td>
                        <td className='w-250'><input type="checkbox" id="cbGA_12" name="cbGA_12" className='add-only' value="Thin" /> Thin</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbGA_13" name="cbGA_13" className='add-only' value="Overweight" /> Overweight</td>
                        <td className='w-250'><input type="checkbox" id="cbGA_14" name="cbGA_14" className='add-only' value="Obese" /> Obese</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGA_15" name="cbGA_15" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtGA_15" name="txtGA_15" className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Behavior & Psychomotor Activity</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbBxPA_1" name="cbBxPA_1" className='add-only' value="Normal" /> Normal</td>
                        <td className='w-250'><input type="checkbox" id="cbBxPA_2" name="cbBxPA_2" className='add-only' value="Overactive" /> Overactive</td>
                        <td className='w-250'><input type="checkbox" id="cbBxPA_3" name="cbBxPA_3" className='add-only' value="Hypoactive" /> Hypoactive</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbBxPA_4" name="cbBxPA_4" className='add-only' value="Catatonia" /> Catatonia</td>
                        <td className='w-250'><input type="checkbox" id="cbBxPA_5" name="cbBxPA_5" className='add-only' value="Tremor" /> Tremor</td>
                        <td className='w-250'><input type="checkbox" id="cbBxPA_6" name="cbBxPA_6" className='add-only' value="Tics" /> Tics</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbBxPA_7" name="cbBxPA_7" className='add-only' value="Combative" /> Combative</td>
                        <td className='w-250'><input type="checkbox" id="cbBxPA_8" name="cbBxPA_8" className='add-only' value="Abnormal Gait" /> Abnormal Gait</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbBxPA_9" name="cbBxPA_9" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtBxPA_9" name="txtBxPA_9" className='add-only' />
                </p>

                <span className='eleHeader'>Attitude</span>
                <table>
                    <tr>
                        <td className='w-750'></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAtt_1" name="cbAtt_1" className='add-only' value="Optimal" /> Optimal</td>
                        <td className='w-250'><input type="checkbox" id="cbAtt_2" name="cbAtt_2" className='add-only' value="Constructive" /> Constructive</td>
                        <td className='w-250'><input type="checkbox" id="cbAtt_3" name="cbAtt_3" className='add-only' value="Motivated" /> Motivated</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAtt_4" name="cbAtt_4" className='add-only' value="Obstructive" /> Obstructive</td>
                        <td className='w-250'><input type="checkbox" id="cbAtt_5" name="cbAtt_5" className='add-only' value="Adversarial" /> Adversarial</td>
                        <td className='w-250'><input type="checkbox" id="cbAtt_6" name="cbAtt_6" className='add-only' value="Inaccessible" /> Inaccessible</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAtt_7" name="cbAtt_7" className='add-only' value="Cooperative" /> Cooperative</td>
                        <td className='w-250'><input type="checkbox" id="cbAtt_8" name="cbAtt_8" className='add-only' value="Seductive" /> Seductive</td>
                        <td className='w-250'><input type="checkbox" id="cbAtt_9" name="cbAtt_9" className='add-only' value="Defensive" /> Defensive</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAtt_10" name="cbAtt_10" className='add-only' value="Hostile" /> Hostile</td>
                        <td className='w-250'><input type="checkbox" id="cbAtt_11" name="cbAtt_11" className='add-only' value="Guarded" /> Guarded</td>
                        <td className='w-250'><input type="checkbox" id="cbAtt_12" name="cbAtt_12" className='add-only' value="Apathetic" /> Apathetic</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAtt_13" name="cbAtt_13" className='add-only' value="Evasive" /> Evasive</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAtt_14" name="cbAtt_14" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtAtt_14" name="txtAtt_14" className='add-only' />
                </p>

                <span className='eleHeader'>Speech</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSpeech_1" name="cbSpeech_1" className='add-only' value="Normal" /> Normal</td>
                        <td className='w-250'><input type="checkbox" id="cbSpeech_2" name="cbSpeech_2" className='add-only' value="Spontaneous" /> Spontaneous</td>
                        <td className='w-250'><input type="checkbox" id="cbSpeech_3" name="cbSpeech_3" className='add-only' value="Slow" /> Slow</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSpeech_4" name="cbSpeech_4" className='add-only' value="Impoverished" /> Impoverished</td>
                        <td className='w-250'><input type="checkbox" id="cbSpeech_5" name="cbSpeech_5" className='add-only' value="Hesitant" /> Hesitant</td>
                        <td className='w-250'><input type="checkbox" id="cbSpeech_6" name="cbSpeech_6" className='add-only' value="Monotonous" /> Monotonous</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSpeech_7" name="cbSpeech_7" className='add-only' value="Soft/Whispered" /> Soft/Whispered</td>
                        <td className='w-250'><input type="checkbox" id="cbSpeech_8" name="cbSpeech_8" className='add-only' value="Mumbled" /> Mumbled</td>
                        <td className='w-250'><input type="checkbox" id="cbSpeech_9" name="cbSpeech_9" className='add-only' value="Rapid" /> Rapid</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSpeech_10" name="cbSpeech_10" className='add-only' value="Pressured" /> Pressured</td>
                        <td className='w-250'><input type="checkbox" id="cbSpeech_11" name="cbSpeech_11" className='add-only' value="Verbose" /> Verbose</td>
                        <td className='w-250'><input type="checkbox" id="cbSpeech_12" name="cbSpeech_12" className='add-only' value="Loud" /> Loud</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSpeech_13" name="cbSpeech_13" className='add-only' value="Slurred" /> Slurred</td>
                        <td className='w-250'><input type="checkbox" id="cbSpeech_14" name="cbSpeech_14" className='add-only' value="Impediment" /> Impediment</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech_15" name="cbSpeech_15" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtSpeech_15" name="txtSpeech_15" className='add-only' />
                </p>

                <span className='eleHeader'>Mood</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbMood_1" name="cbMood_1" className='add-only' value="Dysphoric" /> Dysphoric</td>
                        <td className='w-250'><input type="checkbox" id="cbMood_2" name="cbMood_2" className='add-only' value="Euthymic" /> Euthymic</td>
                        <td className='w-250'><input type="checkbox" id="cbMood_3" name="cbMood_3" className='add-only' value="Expansive" /> Expansive</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbMood_4" name="cbMood_4" className='add-only' value="Irritable" /> Irritable</td>
                        <td className='w-250'><input type="checkbox" id="cbMood_5" name="cbMood_5" className='add-only' value="Labile" /> Labile</td>
                        <td className='w-250'><input type="checkbox" id="cbMood_6" name="cbMood_6" className='add-only' value="Elevated" /> Elevated</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbMood_7" name="cbMood_7" className='add-only' value="Euphoric" /> Euphoric</td>
                        <td className='w-250'><input type="checkbox" id="cbMood_8" name="cbMood_8" className='add-only' value="Ecstatic" /> Ecstatic</td>
                        <td className='w-250'><input type="checkbox" id="cbMood_9" name="cbMood_9" className='add-only' value="Depressed" /> Depressed</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbMood_10" name="cbMood_10" className='add-only' value="Grief/Mouring" /> Grief/Mouring</td>
                        <td className='w-250'><input type="checkbox" id="cbMood_11" name="cbMood_11" className='add-only' value="Alexithymic" /> Alexithymic</td>
                        <td className='w-250'><input type="checkbox" id="cbMood_12" name="cbMood_12" className='add-only' value="Elated" /> Elated</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbMood_13" name="cbMood_13" className='add-only' value="Hypomaniac" /> Hypomaniac</td>
                        <td className='w-250'><input type="checkbox" id="cbMood_14" name="cbMood_14" className='add-only' value="Manic" /> Manic</td>
                        <td className='w-250'><input type="checkbox" id="cbMood_15" name="cbMood_15" className='add-only' value="Anxious" /> Anxious</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbMood_16" name="cbMood_16" className='add-only' value="Tense" /> Tense</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMood_17" name="cbMood_17" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtMood_17" name="txtMood_17" className='add-only' />
                </p>

                <span className='eleHeader'>Affect</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAffect_1" name="cbAffect_1" className='add-only' value="Appropriate" /> Appropriate</td>
                        <td className='w-250'><input type="checkbox" id="cbAffect_2" name="cbAffect_2" className='add-only' value="Inappropriate" /> Inappropriate</td>
                        <td className='w-250'><input type="checkbox" id="cbAffect_3" name="cbAffect_3" className='add-only' value="Blunted" /> Blunted</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAffect_4" name="cbAffect_4" className='add-only' value="Restricted" /> Restricted</td>
                        <td className='w-250'><input type="checkbox" id="cbAffect_5" name="cbAffect_5" className='add-only' value="Flat" /> Flat</td>
                        <td className='w-250'><input type="checkbox" id="cbAffect_6" name="cbAffect_6" className='add-only' value="Labile" /> Labile</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAffect_7" name="cbAffect_7" className='add-only' value="Tearful" /> Tearful</td>
                        <td className='w-250'><input type="checkbox" id="cbAffect_8" name="cbAffect_8" className='add-only' value="Intense" /> Intense</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffect_9" name="cbAffect_9" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtAffect_9" name="txtAffect_9" className='add-only' />
                </p>

                <span className='eleHeader'>Perceptual Disturbances</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbPD_0" name="cbPD_0" className='add-only' value="NA" /> NA</td>
                        <td className='w-250'><input type="checkbox" id="cbPD_1" name="cbPD_1" className='add-only' value="None" /> None</td>
                        <td className='w-250'><input type="checkbox" id="cbPD_2" name="cbPD_2" className='add-only' value="Auditory Hallucinations" /> Auditory Hallucinations</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbPD_4" name="cbPD_4" className='add-only' value="Olfactory Hallucinations" /> Olfactory Hallucinations</td>
                        <td className='w-250'><input type="checkbox" id="cbPD_5" name="cbPD_5" className='add-only' value="Tactile Hallucinations" /> Tactile Hallucinations</td>
                        <td className='w-250'><input type="checkbox" id="cbPD_3" name="cbPD_3" className='add-only' value="Visual Hallucinations" /> Visual Hallucinations</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPD_6" name="cbPD_6" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtPD_6" name="txtPD_6" className='add-only' />
                </p>

                <span className='eleHeader'>Thought Process</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbTP_1" name="cbTP_1" className='add-only' value="Logical/Coherent" /> Logical/Coherent</td>
                        <td className='w-250'><input type="checkbox" id="cbTP_2" name="cbTP_2" className='add-only' value="Incomprehensible" /> Incomprehensible</td>
                        <td className='w-250'><input type="checkbox" id="cbTP_3" name="cbTP_3" className='add-only' value="Incoherent" /> Incoherent</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbTP_4" name="cbTP_4" className='add-only' value="Flight of Ideas" /> Flight of Ideas</td>
                        <td className='w-250'><input type="checkbox" id="cbTP_5" name="cbTP_5" className='add-only' value="Loose Associations" /> Loose Associations</td>
                        <td className='w-250'><input type="checkbox" id="cbTP_6" name="cbTP_6" className='add-only' value="Tangential" /> Tangential</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbTP_7" name="cbTP_7" className='add-only' value="Circumstantial" /> Circumstantial</td>
                        <td className='w-250'><input type="checkbox" id="cbTP_8" name="cbTP_8" className='add-only' value="Rambling" /> Rambling</td>
                        <td className='w-250'><input type="checkbox" id="cbTP_9" name="cbTP_9" className='add-only' value="Evasive" /> Evasive</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbTP_10" name="cbTP_10" className='add-only' value="Racing Thoughts" /> Racing Thoughts</td>
                        <td className='w-250'><input type="checkbox" id="cbTP_11" name="cbTP_11" className='add-only' value="Perseveration" /> Perseveration</td>
                        <td className='w-250'><input type="checkbox" id="cbTP_12" name="cbTP_12" className='add-only' value="Thought Blocking" /> Thought Blocking</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbTP_13" name="cbTP_13" className='add-only' value="Concrete" /> Concrete</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTP_14" name="cbTP_14" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtTP_14" name="txtTP_14" className='add-only' />
                </p>

                <span className='eleHeader'>Thought Content</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbTC_1" name="cbTC_1" className='add-only' value="Preoccupations" /> Preoccupations</td>
                        <td className='w-250'><input type="checkbox" id="cbTC_2" name="cbTC_2" className='add-only' value="Obsessions" /> Obsessions</td>
                        <td className='w-250'><input type="checkbox" id="cbTC_3" name="cbTC_3" className='add-only' value="Compulsions" /> Compulsions</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbTC_4" name="cbTC_4" className='add-only' value="Phobias" /> Phobias</td>
                        <td className='w-250'><input type="checkbox" id="cbTC_5" name="cbTC_5" className='add-only' value="Delusions" /> Delusions</td>
                        <td className='w-250'><input type="checkbox" id="cbTC_6" name="cbTC_6" className='add-only' value="Thought Broadcasting" /> Thought Broadcasting</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbTC_7" name="cbTC_7" className='add-only' value="Thought Insertion" /> Thought Insertion</td>
                        <td className='w-250'><input type="checkbox" id="cbTC_8" name="cbTC_8" className='add-only' value="Thought Withdrawal" /> Thought Withdrawal</td>
                        <td className='w-250'><input type="checkbox" id="cbTC_9" name="cbTC_9" className='add-only' value="Ideas of Reference" /> Ideas of Reference</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbTC_10" name="cbTC_10" className='add-only' value="Ideas of Influence" /> Ideas of Influence</td>
                        <td className='w-250'><input type="checkbox" id="cbTC_11" name="cbTC_11" className='add-only' value="Delusions" /> Delusions</td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTC_12" name="cbTC_12" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtTC_12" name="txtTC_12" className='add-only' />
                </p>

                <span className='eleHeader'>Suicidal/Homicidal Ideation</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSHI_NR" name="cbSHI_NR" className='add-only' value="None Reported" /> None Reported</td>
                        <td className='w-250'><input type="checkbox" id="cbSHI_NI" name="cbSHI_NI" className='add-only' value="None Identified" /> None Identified</td>
                        <td className='w-250'><input type="checkbox" id="cbSHI_1" name="cbSHI_1" className='add-only' value="Suicide Thoughts" /> Suicide Thoughts</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSHI_2" name="cbSHI_2" className='add-only' value="Suicide Attempts" /> Suicide Attempts</td>
                        <td className='w-250'><input type="checkbox" id="cbSHI_3" name="cbSHI_3" className='add-only' value="Suicidal Intent" /> Suicidal Intent</td>
                        <td className='w-250'><input type="checkbox" id="cbSHI_4" name="cbSHI_4" className='add-only' value="Suicidal Plans" /> Suicidal Plans</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSHI_5" name="cbSHI_5" className='add-only' value="History of Self" /> History of Self-Injurious Behavior</td>
                        <td className='w-250'><input type="checkbox" id="cbSHI_6" name="cbSHI_6" className='add-only' value="Homicidal Thoughts" /> Homicidal Thoughts</td>
                        <td className='w-250'><input type="checkbox" id="cbSHI_7" name="cbSHI_7" className='add-only' value="Homicidal Attempts" /> Homicidal Attempts</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSHI_8" name="cbSHI_8" className='add-only' value="Homicidal Intent" /> Homicidal Intent</td>
                        <td className='w-250'><input type="checkbox" id="cbSHI_9" name="cbSHI_9" className='add-only' value="Homicidal Plans" /> Homicidal Plans</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHI_10" name="cbSHI_10" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtSHI_10" name="txtSHI_10" className='add-only' />
                </p>

                <span className='eleHeader'>Sensorium/Cognition</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSC_1" name="cbSC_1" className='add-only' value="Alert" /> Alert</td>
                        <td className='w-250'><input type="checkbox" id="cbSC_2" name="cbSC_2" className='add-only' value="Lethargic" /> Lethargic</td>
                        <td className='w-250'><input type="checkbox" id="cbSC_3" name="cbSC_3" className='add-only' value="Somnolent" /> Somnolent</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSC_4" name="cbSC_4" className='add-only' value="Stuporous" /> Stuporous</td>
                        <td className='w-250'><input type="checkbox" id="cbSC_5" name="cbSC_5" className='add-only' value="Oriented to Person" /> Oriented to Person</td>
                        <td className='w-250'><input type="checkbox" id="cbSC_6" name="cbSC_6" className='add-only' value="Oriented to Place" /> Oriented to Place</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSC_7" name="cbSC_7" className='add-only' value="Oriented to Time" /> Oriented to Time</td>
                        <td className='w-250'><input type="checkbox" id="cbSC_8" name="cbSC_8" className='add-only' value="Oriented to Situation" /> Oriented to Situation</td>
                        <td className='w-250'><input type="checkbox" id="cbSC_9" name="cbSC_9" className='add-only' value="Normal Concentration" /> Normal Concentration</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSC_10" name="cbSC_10" className='add-only' value="Impaired Concentration" /> Impaired Concentration</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSC_11" name="cbSC_11" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtSC_11" name="txtSC_11" className='add-only' />
                </p>

                <span className='eleHeader'>Remote Memory</span>
                <table>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRemMem_1" name="cbRemMem_1" className='add-only' value="Normal" /> Normal</td>
                        <td className='w-375'><input type="checkbox" id="cbRemMem_2" name="cbRemMem_2" className='add-only' value="Impaired" /> Impaired</td>
                    </tr>
                </table>

                <span className='eleHeader'>Recent Memory</span>
                <table>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRecMem_1" name="cbRecMem_1" className='add-only' value="Normal" /> Normal</td>
                        <td className='w-375'><input type="checkbox" id="cbRecMem_2" name="cbRecMem_2" className='add-only' value="Impaired" /> Impaired</td>
                    </tr>
                </table>

                <span className='eleHeader'>Immediate Recall</span>
                <table>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbIR_1" name="cbIR_1" className='add-only' value="Normal" /> Normal</td>
                        <td className='w-375'><input type="checkbox" id="cbIR_2" name="cbIR_2" className='add-only' value="Impaired" /> Impaired</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIR_3" name="cbIR_3" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtIR_3" name="txtIR_3" className='add-only' />
                </p>

                <span className='eleHeader'>Intellectual Functioning</span>
                <span className='small'>(estimate)</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbIF_1" name="cbIF_1" className='add-only' value="Above Average" /> Above Average</td>
                        <td className='w-250'><input type="checkbox" id="cbIF_2" name="cbIF_2" className='add-only' value="Normal/Average" /> Normal/Average</td>
                        <td className='w-250'><input type="checkbox" id="cbIF_3" name="cbIF_3" className='add-only' value="Borderline" /> Borderline</td>
                    </tr>
                </table>

                <span className='eleHeader'>Judgment</span>
                <table>
                    <tr>
                        <td className='w-750'></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbJudg_1" name="cbJudg_1" className='add-only' value="Critical Judgment Intact" /> Critical Judgment Intact</td>
                        <td className='w-250'><input type="checkbox" id="cbJudg_2" name="cbJudg_2" className='add-only' value="Impaired Judgment" /> Impaired Judgment</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbJudg_3" name="cbJudg_3" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtJudg_3" name="txtJudg_3" className='add-only' />
                </p>

                <span className='eleHeader'>Insight</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbIns_1" name="cbIns_1" className='add-only' value="True Emotional Insight" /> True Emotional Insight</td>
                        <td className='w-200'><input type="checkbox" id="cbIns_2" name="cbIns_2" className='add-only' value="Intellectual Insight" /> Intellectual Insight</td>
                        <td className='w-300'><input type="checkbox" id="cbIns_3" name="cbIns_3" className='add-only' value="Some Awareness of Illness/Symptoms" /> Some Awareness of Illness/Symptoms</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbIns_4" name="cbIns_4" className='add-only' value="Impaired Insight" /> Impaired Insight</td>
                        <td className='w-500'><input type="checkbox" id="cbIns_5" name="cbIns_5" className='add-only' value="Denial" /> Denial</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIns_6" name="cbIns_6" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtIns_6" name="txtIns_6" className='add-only' />
                </p>

                <span className='eleHeader'>Impulse Control</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbIC_1" name="cbIC_1" className='add-only' value="Able to Resist Impulses" /> True Emotional Insight</td>
                        <td className='w-200'><input type="checkbox" id="cbIC_2" name="cbIC_2" className='add-only' value="Recent Impulsive Behavior" /> Intellectual Insight</td>
                        <td className='w-300'><input type="checkbox" id="cbIC_3" name="cbIC_3" className='add-only' value="Impaired Impulse Control" /> Some Awareness of Illness/Symptoms</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbIC_4" name="cbIC_4" className='add-only' value="Compulsions" /> Impaired Insight</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIC_5" name="cbIC_5" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="Text2" name="cbIC_5" className='add-only' />
                </p>

                <h4>Risk Assessment</h4>
                <h5>Assess potential risk of harm to self or others, including patterns of risk behavior and/or risk due to personality factors, substance use, criminogenic factors, exposure to elements, exploitation, abuse, neglect, suicidal or homicidal history, self-injury, psychosis, impulsiveness, etc.</h5>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Risk of Harm to Self</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRHS_NR" name="cbRHS_NR" className='add-only' value="None Reported" /> None Reported</td>
                        <td className='w-375'><input type="checkbox" id="cbRHS_NI" name="cbRHS_NI" className='add-only' value="None Identified" /> None Identified</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRHS_1" name="cbRHS_1" className='add-only' value="Prior Suicide Attempt" /> Prior Suicide Attempt</td>
                        <td className='w-375'><input type="checkbox" id="cbRHS_2" name="cbRHS_2" className='add-only' value="Stated Plan/Intent" /> Stated Plan/Intent</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRHS_3" name="cbRHS_3" className='add-only' value="Access to means" /> Access to means (weapons, pills, etc.)</td>
                        <td className='w-375'><input type="checkbox" id="cbRHS_4" name="cbRHS_4" className='add-only' value="Recent Loss" /> Recent Loss</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRHS_11" name="cbRHS_11" className='add-only' value="Suicide of friend/acquaintance" /> Suicide of friend/acquaintance</td>
                        <td className='w-375'><input type="checkbox" id="cbRHS_6" name="cbRHS_6" className='add-only' value="Family History of Suicide" /> Family History of Suicide</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRHS_7" name="cbRHS_7" className='add-only' value="Terminal Illness" /> Terminal Illness</td>
                        <td className='w-375'><input type="checkbox" id="cbRHS_8" name="cbRHS_8" className='add-only' value="Substance Abuse" /> Substance Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRHS_9" name="cbRHS_9" className='add-only' value="Marked lack of support" /> Marked lack of support</td>
                        <td className='w-375'><input type="checkbox" id="cbRHS_10" name="cbRHS_10" className='add-only' value="Psychosis" /> Psychosis</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type="checkbox" id="cbRHS_5" name="cbRHS_5" className='add-only' value="Presence of Behavioral Cues" /> Presence of Behavioral Cues (isolation, giving away possessions, rapid mood swings, etc.)</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRHS_12" name="cbRHS_12" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>

                <p className='w-375'>
                    <input type='text' id="txtRHS_12" name="txtRHS_12" className='add-only' />
                </p>

                <span className='eleHeader'>Risk of Harm to Others</span>
                <table>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRHO_NR" name="cbRHO_NR" className='add-only' value="None Reported" /> None Reported</td>
                        <td className='w-375'><input type="checkbox" id="cbRHO_NI" name="cbRHO_NI" className='add-only' value="None Identified" /> None Identified</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRHO_1" name="cbRHO_1" className='add-only' value="Prior Suicide Attempt" /> Prior Acts of Violence</td>
                        </tr>
                        <tr>
                        <td className='w-750'>If yes, when was most recent violent act? <input type='text' id="txtRHO_" name="txtRHO_" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRHO_2" name="cbRHO_2" className='add-only' value="Destruction of property" /> Destruction of property</td>
                        <td className='w-375'><input type="checkbox" id="cbRHO_3" name="cbRHO_3" className='add-only' value="Arrests for violence" /> Arrests for violence</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRHO_4" name="cbRHO_4" className='add-only' value="Access to means" /> Access to means (weapons)</td>
                        <td className='w-375'><input type="checkbox" id="cbRHO_5" name="cbRHO_5" className='add-only' value="Substance use" /> Substance use</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRHO_6" name="cbRHO_6" className='add-only' value="Physically abused as child" /> Physically abused as child</td>
                        <td className='w-375'><input type="checkbox" id="cbRHO_7" name="cbRHO_7" className='add-only' value="Was physically abusive as a child" /> Was physically abusive as a child</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRHO_8" name="cbRHO_8" className='add-only' value="Harms animals" /> Harms animals</td>
                        <td className='w-375'><input type="checkbox" id="cbRHO_9" name="cbRHO_9" className='add-only' value="Fire setting" /> Fire setting</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRHO_10" name="cbRHO_10" className='add-only' value="Angry mood/agitation" /> Angry mood/agitation</td>
                        <td className='w-375'><input type="checkbox" id="cbRHO_11" name="cbRHO_11" className='add-only' value="Prior hospitalizations for danger to others" /> Prior hospitalizations for danger to others</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRHO_12" name="cbRHO_12" className='add-only' value="Psychosis" /> Psychosis/command hallucinations</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbRHO_13" name="cbRHO_13" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtRHO_13" name="txtRHO_13" className='add-only' />
                </p>

                <span className='eleHeader'>Client/Member Safety & Other Risk Factors</span>
                <table>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRSORF_NR" name="cbRSORF_NR" className='add-only' value="None Reported" /> None Reported</td>
                        <td className='w-375'><input type="checkbox" id="cbRSORF_NI" name="cbRSORF_NI" className='add-only' value="None Identified" /> None Identified</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRSORF_6" name="cbRSORF_6" className='add-only' value="Past involvement with Child or Adult Protective Services" /> Past involvement with Child or Adult Protective Services</td>
                        <td className='w-375'><input type="checkbox" id="cbRSORF_2" name="cbRSORF_2" className='add-only' value="Serious" /> Feels currently being harmed/hurt/abused/threatened by someone</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRSORF_5" name="cbRSORF_5" className='add-only' value="Engages in dangerous sexual behavior" /> Engages in dangerous sexual behavior</td>
                        <td className='w-375'><input type="checkbox" id="cbRSORF_1" name="cbRSORF_1" className='add-only' value="Feels unsafe in current living environment" /> Feels unsafe in current living environment</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRSORF_7" name="cbRSORF_7" className='add-only' value="Relapse/decompensation triggers" /> Relapse/decompensation triggers</td>
                        <td className='w-375'><input type="checkbox" id="cbInappSex" name="cbInappSex" className='add-only' value="Inappropriate sexual behaviors" /> Inappropriate sexual behaviors</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbSexOffender" name="cbSexOffender" className='add-only' value="Sex offender status" /> Sex offender status</td>
                        <td className='w-375'><input type="checkbox" id="cbPendingSex" name="cbPendingSex" className='add-only' value="Pending sex offense charge" /> Pending sex offense charge</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbReportInvest" name="cbReportInvest" className='add-only' value="Report or Investigation" /> Report or Investigation</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRSORF_8" name="cbRSORF_8" className='add-only' value="Other" /> Other:
                            <input type='text' id="txtRSORF_10" name="txtRSORF_10" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbSexOther" name="cbSexOther" className='add-only' value="Other" /> Other:
                            <input type='text' id="txtSexOther" name="txtSexOther" className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional Risk Factors</span>
                    <textarea id="txtAddRiskFact" name="txtAddRiskFact" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Describe recipient's preferences and desires for addressing risk factors, including any Mental Health Advance Directives or plan of response to periods of decompensation/relapse</span>
                    <span className='small'>(Ex. Resources recipient feels comfortable reaching out to for assistance in a crisis.)</span>
                    <textarea id="txtPrefDesire" name="txtPrefDesire" className='add-only'></textarea>
                </p>
                <h4>Cultural & Language Preferences</h4>
                <h5>(Language, Customs/Values/Preferences)</h5>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Spiritual Beliefs/Preferences:</span>
                            <input type='text' id="Text3" name="txtRSORF_8" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Cultural Beliefs/Preferences:</span>
                            <input type='text' id="Text4" name="txtRSORF_9" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h2>Principal Diagnosis</h2>
                <h5>(Provide principal DSM-V/ICD-10 behavioral and medical diagnoses)</h5>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Code</span>
                        </td>
                        <td className='w-600'>
                            <span className='eleHeader'>Description</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtCode_1" name="txtCode_1" className='add-only' /></td>
                        <td className='w-600'><input type='text' id="txtDesc_1" name="txtDesc_1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtCode_2" name="txtCode_2" className='add-only' /></td>
                        <td className='w-600'><input type='text' id="txtDesc_2" name="txtDesc_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtCode_3" name="txtCode_3" className='add-only' /></td>
                        <td className='w-600'><input type='text' id="txtDesc_3" name="txtDesc_3" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtCode_4" name="txtCode_4" className='add-only' /></td>
                        <td className='w-600'><input type='text' id="txtDesc_4" name="txtDesc_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id="txtCode_5" name="txtCode_5" className='add-only' /></td>
                        <td className='w-600'><input type='text' id="txtDesc_5" name="txtDesc_5" className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Interpretive Summary</span>
                    <span className='small'>Briefly describe client/member's global preferences/hopes for recovery, your clinical summary, and recommended treatments/assessments, level of care, duration.</span>
                    <textarea id="txtInterpretiveSumm" name="txtInterpretiveSumm" className='add-only'></textarea>
                </p>

                <span className='eleHeader'>Recommended Services</span>
                <span className='small'>Check all that apply</span>
                <table>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRecSvcs_MTS" name="cbRecSvcs_MTS" className='add-only' value="MTS (Medication Training & Support)" /> MTS (Medication Training & Support)</td>
                        <td className='w-375'><input type="checkbox" id="cbRecSvcs_TCM" name="cbRecSvcs_TCM" className='add-only' value="TCM (Targeted Case Management)" /> TCM (Targeted Case Management)</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRecSvcs_SKTD" name="cbRecSvcs_SKTD" className='add-only' value="SKTD (Skills Training & Development)" /> SKTD (Skills Training & Development)</td>
                        <td className='w-375'><input type="checkbox" id="cbRecSvcs_CI" name="cbRecSvcs_CI" className='add-only' value="CI (Crisis Intervention)" /> CI (Crisis Intervention) - if necessary</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRecSvcs_1" name="cbRecSvcs_" className='add-only' value="Family Therapy" /> Family Therapy</td>
                        <td className='w-375'><input type="checkbox" id="cbRecSvcs_2" name="cbRecSvcs_" className='add-only' value="Individual Therapy" /> Individual Therapy</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRecSvcs_3" name="cbRecSvcs_" className='add-only' value="Group Therapy" /> Group Therapy</td>
                        <td className='w-375'><input type="checkbox" id="cbRecSvcs_4" name="cbRecSvcs_4" className='add-only' value="Alcohol/Drug Assessment" /> Alcohol/Drug Assessment</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRecSvcs_5" name="cbRecSvcs_5" className='add-only' value="Alcohol/ Drug Individual Therapy" /> Alcohol/ Drug Individual Therapy</td>
                        <td className='w-375'><input type="checkbox" id="cbRecSvcs_6" name="cbRecSvcs_6" className='add-only' value="PSR" /> PSR</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="checkbox" id="cbRecSvcs_7" name="cbRecSvcs_7" className='add-only' value="CPST" /> CPST</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRecSvcs_8" name="cbRecSvcs_8" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtRecSvcs_8" name="txtRecSvcs_8" className='add-only' />
                </p>

                <span className='eleHeader'>Other Services/Linkages Needed</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbOtherSvcs_1" name="cbOtherSvcs_1" className='add-only' value="Vocational Services" /> Vocational Services</td>
                        <td className='w-250'><input type="checkbox" id="cbOtherSvcs_2" name="cbOtherSvcs_2" className='add-only' value="Social Services" /> Social Services</td>
                        <td className='w-250'><input type="checkbox" id="cbOtherSvcs_3" name="cbOtherSvcs_3" className='add-only' value="Educational Services" /> Educational Services</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbOtherSvcs_4" name="cbOtherSvcs_4" className='add-only' value="Medical Services/PCP" /> Medical Services/PCP</td>
                        <td className='w-250'><input type="checkbox" id="cbOtherSvcs_5" name="cbOtherSvcs_5" className='add-only' value="Self help Groups" /> Self help Groups;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOtherSvcs_6" name="cbOtherSvcs_6" className='add-only' value="Other" /> Other:
                        </td>
                    </tr>
                </table>
                <p className='w-375'>
                    <input type='text' id="txtOtherSvcs_6" name="txtOtherSvcs_6" className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments</span>
                    <textarea id="txtOtherSvcsAddlCommm" name="txtOtherSvcsAddlCommm" className='add-only'></textarea>
                </p>
                <h2>Signature</h2>
                <table>
                    <tr>
                        <td className='signature w-350'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-100'>&nbsp;</td>
                        <td className='signature w-100'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-350">Printed Name of Assessor</td>
                        <td className="small w-200">Signature</td>
                        <td className="small w-100">LMHP Status</td>
                        <td className="small w-100">Date</td>
                    </tr>
                </table>

            </div>
        </form>

    )
}











  







